<div class="viewer-container">
  <button mat-icon-button class="close-btn" (click)="dialogRef.close()" matTooltip="Cerrar (Esc)">
    <mat-icon>close</mat-icon>
  </button>

  <div class="image-wrapper">
    <div cdkDrag class="drag-container">
      <img [src]="data.url" 
           [style.transform]="getTransform()"
           [style.filter]="getFilter()"
           class="main-image" 
           alt="Inspección detallada"
           (dblclick)="reset()">
    </div>
  </div>

  <div class="controls-toolbar">
    <div class="control-group">
      <button mat-icon-button (click)="zoomOut()" matTooltip="Alejar"><mat-icon>zoom_out</mat-icon></button>
      <span class="value-text">{{ (scale * 100) | number:'1.0-0' }}%</span>
      <button mat-icon-button (click)="zoomIn()" matTooltip="Acercar"><mat-icon>zoom_in</mat-icon></button>
    </div>

    <div class="divider"></div>

    <div class="control-group">
      <button mat-icon-button (click)="rotateLeft()" matTooltip="Girar Izquierda"><mat-icon>rotate_left</mat-icon></button>
      <button mat-icon-button (click)="rotateRight()" matTooltip="Girar Derecha"><mat-icon>rotate_right</mat-icon></button>
      <button mat-icon-button (click)="toggleFlip()" matTooltip="Efecto Espejo"><mat-icon>flip</mat-icon></button>
    </div>

    <div class="divider"></div>

    <div class="control-group sliders-group">
      <div class="slider-wrapper" matTooltip="Brillo">
        <mat-icon class="small-icon">light_mode</mat-icon>
        <mat-slider min="50" max="150" step="5" discrete>
          <input matSliderThumb [(ngModel)]="brightness">
        </mat-slider>
      </div>
      <div class="slider-wrapper" matTooltip="Contraste / Atenuación">
        <mat-icon class="small-icon">contrast</mat-icon>
        <mat-slider min="50" max="150" step="5" discrete>
          <input matSliderThumb [(ngModel)]="contrast">
        </mat-slider>
      </div>
    </div>

    <div class="divider"></div>

    <div class="control-group">
      <button mat-icon-button color="primary" (click)="downloadImage()" matTooltip="Descargar Imagen">
        <mat-icon>download</mat-icon>
      </button>
      
      <button mat-icon-button color="warn" (click)="reset()" matTooltip="Restablecer Valores">
        <mat-icon>restart_alt</mat-icon>
      </button>
    </div>
  </div>
</div>